import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCup: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="cup, tea, coffee, mug"><path fillRule="evenodd" clipRule="evenodd" d="M3 3.75C3 3.33579 3.33579 3 3.75 3H16.25C16.6642 3 17 3.33579 17 3.75V6H17.5C19.433 6 21 7.567 21 9.5C21 11.433 19.433 13 17.5 13H17V17.25C17 19.3211 15.3211 21 13.25 21H6.75C4.67893 21 3 19.3211 3 17.25V3.75ZM17 11.5H17.5C18.6046 11.5 19.5 10.6046 19.5 9.5C19.5 8.39543 18.6046 7.5 17.5 7.5H17V11.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCup;
